import Button from '@app-studio-web/ui/components/Button'
import Layout from '@app-studio-web/ui/components/Layout'
import * as Sentry from '@sentry/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Form, useSubmit } from 'react-router-dom'

export default function FeedbackGenderStudyPage() {
  const { t } = useTranslation()
  const submit = useSubmit()
  const [gender, setGender] = useState<string>('other')

  useEffect(() => {
    try {
      const storedGender = sessionStorage.getItem('onboarding_gender')
      if (storedGender) {
        setGender(storedGender)
      }
    } catch (error) {
      Sentry.captureException(error)
    }
  }, [])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  const getStudyContent = () => {
    switch (gender) {
      case 'female':
        return {
          stat: '67%',
          title: t('pages.onboarding.feedbackGenderStudy.femaleTitle'),
          description: t(
            'pages.onboarding.feedbackGenderStudy.femaleDescription',
          ),
          source: t('pages.onboarding.feedbackGenderStudy.femaleSource'),
        }
      case 'male':
        return {
          stat: '72%',
          title: t('pages.onboarding.feedbackGenderStudy.maleTitle'),
          description: t(
            'pages.onboarding.feedbackGenderStudy.maleDescription',
          ),
          source: t('pages.onboarding.feedbackGenderStudy.maleSource'),
        }
      default:
        return {
          stat: '78%',
          title: t('pages.onboarding.feedbackGenderStudy.otherTitle'),
          description: t(
            'pages.onboarding.feedbackGenderStudy.otherDescription',
          ),
          source: t('pages.onboarding.feedbackGenderStudy.otherSource'),
        }
    }
  }

  const study = getStudyContent()

  return (
    <Layout>
      <div className="fixed inset-0 -z-10 bg-gradient-to-b from-[#FFFFFF] to-[#EFFBFF]" />
      <div className="flex h-full flex-col text-center">
        <div className="flex grow flex-col items-center justify-center px-4">
          <div className="mb-6 flex h-28 w-28 items-center justify-center rounded-full bg-gradient-to-br from-blue-100 to-purple-100">
            <span className="text-4xl font-bold text-blue-600">
              {study.stat}
            </span>
          </div>

          <h1 className="custom-heading mb-4 text-2xl leading-tight">
            {study.title}
          </h1>

          <p className="mb-4 max-w-sm text-gray-600">{study.description}</p>

          <p className="text-xs text-gray-400 italic">{study.source}</p>
        </div>

        <Form className="shrink-0" method="post" onSubmit={handleSubmit}>
          <Button
            title={t('pages.onboarding.feedbackGenderStudy.buttonContinue')}
            type="submit"
            dataTestId="button-continue"
          />
        </Form>
      </div>
    </Layout>
  )
}
